import { TemplateType } from "@commons-monorepo/index";
import { ReviewsProps } from "./reviews.types";
import { ReviewsSkin1 } from "./skins/reviews-skin-1/reviews-skin-1";
import { ReviewsSkin2 } from "./skins/reviews-skin-2/reviews-skin-2";

export const Reviews = ({
  skin = TemplateType.PRODUCT_REVIEWS_SKIN_1,
  ...props
}: ReviewsProps & { skin?: string }) => {
  return skin === TemplateType.PRODUCT_REVIEWS_SKIN_2 ? (
    <ReviewsSkin2 {...props} />
  ) : (
    <ReviewsSkin1 {...props} />
  );
};
